export const uiConstants = {
    /*
     * Header Constant Types :
     */
    HEADER_LANDING_PAGE: 'HEADER_LANDING_PAGE',
    HEADER_MEDIA: 'HEADER_MEDIA',

};